import React, { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import EditProjectService from "../EditProjectService";
import { useLocation } from "react-router-dom";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import {calculateLength} from "../../../config/helpingFunctions";
import ProjectService from "../../create-projects/CreateProjectService";

type ProjectInfoProps = {
  projectName: any;
  projectId: any;
  onNext: () => void;
};
function ProjectInfo(props: ProjectInfoProps) {
  let urllocation = useLocation();
  const { t } = useTranslation();

  const [projectName, setProjectName] = useState<string>("");
  const [previousProjectName, setPreviousProjectName] = useState<string>("");

  const [comment, setComment] = useState<string>("");
  const [client, setClient] = useState<string>("");
  const [company, setCompany] = useState<string>("");
  const [location, setLocation] = useState<string>("");
  const [observer, setObserver] = useState<string>("");
  const [norm, setNorm] = useState<any>();
  const [errors, setErrors] = useState<any>([]);

  const norms = [
    { name: "Custom", value: "Custom" },
    { name: "DIN 4150-3 (1-315 Hz)", value: "DIN 4150-3 (1-315 Hz)" },
    { name: "DIN 4150-3 (1-80 Hz)", value: "DIN 4150-3 (1-80 Hz)" },
    { name: "DIN 4150-2 (1-80 Hz)", value: "DIN 4150-2 (1-80 Hz)" },
  ];

  const onNormChange = (e: { value: any }) => {
    setNorm(e.value);
  };

  const validate = () => {
    let error: any = {};

    if (projectName === "") {
      error["projectName"] = t('projectName_error');
      setErrors(error);
    }

    if (norm === "" || norm === undefined) {
      error["norm"] = t('norm_error');
      setErrors(error);
    }
    if (Object.keys(error).length !== 0) {
      return false;
    }

    return true;
  };
  const projectService = new ProjectService();

  let editProjectService = new EditProjectService();

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem("lang")!);

    let projectInfo = localStorage.getItem("projectInfo");
    if (projectInfo) {
      let jsonItem = JSON.parse(projectInfo);
      setProjectName(jsonItem["projectName"]);
      setPreviousProjectName(jsonItem["projectName"]);
      setComment(jsonItem["comment"]);
      setClient(jsonItem["client"]);
      setCompany(jsonItem["company"]);
      setLocation(jsonItem["location"]);
      setObserver(jsonItem["observer"]);
      setNorm(jsonItem["norm"]);
    } else {
      editProjectService
        .getProjectDetails(props.projectName, props.projectId)
        .then((response) => {
          const details = response['details'];
          setProjectName(response["project_name"]);
          setPreviousProjectName(response["project_name"]);
          setComment(details['FILE_NOTE']);
          setClient(details['FILE_CLIENT']);
          setCompany(details['FILE_COMPANY']);
          setLocation(details['FILE_LOCATION']);
          setObserver(details['FILE_OBSERVER'])
          setNorm(details['MEASUREMENT_STANDARD'])

          const lengths = calculateLength(details['MEASUREMENT_SAMPLING_RATE'], details['MEASUREMENT_TRACE_LENGTH'], details['MEASUREMENT_PRETRIGGER_LENGTH'])

          let measurements: any = {
            measurementUnit: details['MEASUREMENT_UNIT'],
            measurementRange: details['MEASUREMENT_RANGE'],
            samplingRate: details['MEASUREMENT_SAMPLING_RATE'],
            traceLength: lengths['trLength'],
            pretriggerLength: lengths['preTrLength'],
            measurementGain: details['MEASUREMENT_GAIN'],
            offsetRemover: details['MEASUREMENT_OFFSET_REMOVER'],
            microphoneChannel: details['DEVICE_MICROPHONE_ENABLE'],
            powerSave: details['DEVICE_POWER_SAVE'],
            measurementType: details['MEASUREMENT_TYPE'],
            triggerX: details['MEASUREMENT_TRIGGER_LEVEL_X'],
            triggerY: details['MEASUREMENT_TRIGGER_LEVEL_Y'],
            triggerZ: details['MEASUREMENT_TRIGGER_LEVEL_Z'],
            triggerVR: details['MEASUREMENT_TRIGGER_LEVEL_VR'],
            autoTrigger: details['MEASUREMENT_TRIGGER_AUTO_INTERVAL'],
            axisAutoRotation: details['MEASUREMENT_ROTATION'],
            rotationX: details['MEASUREMENT_ROTATION_MAN_X'],
            rotationY: details['MEASUREMENT_ROTATION_MAN_Y'],
            rotationZ: details['MEASUREMENT_ROTATION_MAN_Z'],
            slowTrace: details['DEVICE_SLOW_TRACE_INTERVAL'],
          };
          localStorage.setItem(
              "measurements",
              JSON.stringify(measurements)
          );
          let deviceMessaging : any ={
          1: {
            checkedValue: details['SMS_USER0_FLAGS'],
            inputValue: details['SMS_USER0_NUMBER'],
            trigger: details['SMS_USER0_FLAGS'] === 7 || details['SMS_USER0_FLAGS'] === 15,
            warning: details['SMS_USER0_FLAGS'] === 6 || details['SMS_USER0_FLAGS'] === 7 || details['SMS_USER0_FLAGS'] === 15 ,
            alarm: details['SMS_USER0_FLAGS'] === 4 || details['SMS_USER0_FLAGS'] === 6 || details['SMS_USER0_FLAGS'] === 7 || details['SMS_USER0_FLAGS'] === 15,
            system: details['SMS_USER0_FLAGS'] === 8 || details['SMS_USER0_FLAGS'] === 15
          },
            2:{
              checkedValue: details['SMS_USER1_FLAGS'],
              inputValue: details['SMS_USER1_NUMBER'],
              trigger: details['SMS_USER1_FLAGS'] === 7 || details['SMS_USER1_FLAGS'] === 15,
              warning: details['SMS_USER1_FLAGS'] === 6 || details['SMS_USER1_FLAGS'] === 7 || details['SMS_USER1_FLAGS'] === 15 ,
              alarm: details['SMS_USER1_FLAGS'] === 4 || details['SMS_USER1_FLAGS'] === 6 || details['SMS_USER1_FLAGS'] === 7 || details['SMS_USER1_FLAGS'] === 15,
              system: details['SMS_USER1_FLAGS'] === 8 || details['SMS_USER1_FLAGS'] === 15
            },
            3:{
              checkedValue: details['SMS_USER2_FLAGS'],
              inputValue: details['SMS_USER2_NUMBER'],
              trigger: details['SMS_USER2_FLAGS'] === 7 || details['SMS_USER2_FLAGS'] === 15,
              warning: details['SMS_USER2_FLAGS'] === 6 || details['SMS_USER2_FLAGS'] === 7 || details['SMS_USER2_FLAGS'] === 15 ,
              alarm: details['SMS_USER2_FLAGS'] === 4 || details['SMS_USER2_FLAGS'] === 6 || details['SMS_USER2_FLAGS'] === 7 || details['SMS_USER2_FLAGS'] === 15,
              system: details['SMS_USER2_FLAGS'] === 8 || details['SMS_USER2_FLAGS'] === 15
            },
            4:{
              checkedValue: details['SMS_USER3_FLAGS'],
              inputValue: details['SMS_USER3_NUMBER'],
              trigger: details['SMS_USER3_FLAGS'] === 7 || details['SMS_USER3_FLAGS'] === 15,
              warning: details['SMS_USER3_FLAGS'] === 6 || details['SMS_USER3_FLAGS'] === 7 || details['SMS_USER3_FLAGS'] === 15 ,
              alarm: details['SMS_USER3_FLAGS'] === 4 || details['SMS_USER3_FLAGS'] === 6 || details['SMS_USER3_FLAGS'] === 7 || details['SMS_USER3_FLAGS'] === 15,
              system: details['SMS_USER3_FLAGS'] === 8 || details['SMS_USER3_FLAGS'] === 15
            },
            5:{
              checkedValue: details['SMS_USER4_FLAGS'],
              inputValue: details['SMS_USER4_NUMBER'],
              trigger: details['SMS_USER4_FLAGS'] === 7 || details['SMS_USER4_FLAGS'] === 15,
              warning: details['SMS_USER4_FLAGS'] === 6 || details['SMS_USER4_FLAGS'] === 7 || details['SMS_USER4_FLAGS'] === 15 ,
              alarm: details['SMS_USER4_FLAGS'] === 4 || details['SMS_USER4_FLAGS'] === 6 || details['SMS_USER4_FLAGS'] === 7 || details['SMS_USER4_FLAGS'] === 15,
              system: details['SMS_USER4_FLAGS'] === 8 || details['SMS_USER4_FLAGS'] === 15
            },
            6:{
              checkedValue: details['SMS_USER5_FLAGS'],
              inputValue: details['SMS_USER5_NUMBER'],
              trigger: details['SMS_USER5_FLAGS'] === 7 || details['SMS_USER5_FLAGS'] === 15,
              warning: details['SMS_USER5_FLAGS'] === 6 || details['SMS_USER5_FLAGS'] === 7 || details['SMS_USER5_FLAGS'] === 15 ,
              alarm: details['SMS_USER5_FLAGS'] === 4 || details['SMS_USER5_FLAGS'] === 6 || details['SMS_USER5_FLAGS'] === 7 || details['SMS_USER5_FLAGS'] === 15,
              system: details['SMS_USER5_FLAGS'] === 8 || details['SMS_USER5_FLAGS'] === 15
            },
            7:{
              inputValue: details['SMS_WARN_LEVEL'],
            },
            8:{
              inputValue: details['SMS_ALARM_LEVEL'],
            },
            9:{
              inputValue: details['SMS_SILENCE_TIME'],
            },
          }
          localStorage.setItem(
              "deviceMessaging",
              JSON.stringify(deviceMessaging)
          );
          let serverMessaging: any = {
            1: {
              checkedValue: details['EMAIL_USER0_FLAGS'],
              inputValue: details['EMAIL_USER0'],
              trigger: details['EMAIL_USER0_FLAGS'] === 7 || details['EMAIL_USER0_FLAGS'] === 15,
              warning: details['EMAIL_USER0_FLAGS'] === 6 || details['EMAIL_USER0_FLAGS'] === 7 || details['EMAIL_USER0_FLAGS'] === 15 ,
              alarm: details['EMAIL_USER0_FLAGS'] === 4 || details['EMAIL_USER0_FLAGS'] === 6 || details['EMAIL_USER0_FLAGS'] === 7 || details['EMAIL_USER0_FLAGS'] === 15,
              system: details['EMAIL_USER0_FLAGS'] === 8|| details['EMAIL_USER0_FLAGS'] === 15
            },
            2:{
              checkedValue: details['EMAIL_USER1_FLAGS'],
              inputValue: details['EMAIL_USER1'],
              trigger: details['EMAIL_USER1_FLAGS'] === 7 || details['EMAIL_USER1_FLAGS'] === 15,
              warning: details['EMAIL_USER1_FLAGS'] === 6 || details['EMAIL_USER1_FLAGS'] === 7 || details['EMAIL_USER1_FLAGS'] === 15 ,
              alarm: details['EMAIL_USER1_FLAGS'] === 4 || details['EMAIL_USER1_FLAGS'] === 6 || details['EMAIL_USER1_FLAGS'] === 7 || details['EMAIL_USER1_FLAGS'] === 15,
              system: details['EMAIL_USER1_FLAGS'] === 8 || details['EMAIL_USER1_FLAGS'] === 15
            },
            3:{
              checkedValue: details['EMAIL_USER2_FLAGS'],
              inputValue: details['EMAIL_USER2'],
              trigger: details['EMAIL_USER2_FLAGS'] === 7 || details['EMAIL_USER2_FLAGS'] === 15,
              warning: details['EMAIL_USER2_FLAGS'] === 6 || details['EMAIL_USER2_FLAGS'] === 7 || details['EMAIL_USER2_FLAGS'] === 15 ,
              alarm: details['EMAIL_USER2_FLAGS'] === 4 || details['EMAIL_USER2_FLAGS'] === 6 || details['EMAIL_USER2_FLAGS'] === 7 || details['EMAIL_USER2_FLAGS'] === 15,
              system: details['EMAIL_USER2_FLAGS'] === 8 || details['EMAIL_USER2_FLAGS'] === 15
            },
            4:{
              checkedValue: details['EMAIL_USER3_FLAGS'],
              inputValue: details['EMAIL_USER3'],
              trigger: details['EMAIL_USER3_FLAGS'] === 7 || details['EMAIL_USER3_FLAGS'] === 15,
              warning: details['EMAIL_USER3_FLAGS'] === 6 || details['EMAIL_USER3_FLAGS'] === 7 || details['EMAIL_USER3_FLAGS'] === 15 ,
              alarm: details['EMAIL_USER3_FLAGS'] === 4 || details['EMAIL_USER3_FLAGS'] === 6 || details['EMAIL_USER3_FLAGS'] === 7 || details['EMAIL_USER3_FLAGS'] === 15,
              system: details['EMAIL_USER3_FLAGS'] === 8 || details['EMAIL_USER3_FLAGS'] === 15
            },
            5:{
              checkedValue: details['EMAIL_USER4_FLAGS'],
              inputValue: details['EMAIL_USER4'],
              trigger: details['EMAIL_USER4_FLAGS'] === 7 || details['EMAIL_USER4_FLAGS'] === 15,
              warning: details['EMAIL_USER4_FLAGS'] === 6 || details['EMAIL_USER4_FLAGS'] === 7 || details['EMAIL_USER4_FLAGS'] === 15 ,
              alarm: details['EMAIL_USER4_FLAGS'] === 4 || details['EMAIL_USER4_FLAGS'] === 6 || details['EMAIL_USER4_FLAGS'] === 7 || details['EMAIL_USER4_FLAGS'] === 15,
              system: details['EMAIL_USER4_FLAGS'] === 8 || details['EMAIL_USER4_FLAGS'] === 15
            },
            6:{
              checkedValue: details['EMAIL_USER5_FLAGS'],
              inputValue: details['EMAIL_USER5'],
              trigger: details['EMAIL_USER5_FLAGS'] === 7 || details['EMAIL_USER5_FLAGS'] === 15,
              warning: details['EMAIL_USER5_FLAGS'] === 6 || details['EMAIL_USER5_FLAGS'] === 7 || details['EMAIL_USER5_FLAGS'] === 15 ,
              alarm: details['EMAIL_USER5_FLAGS'] === 4 || details['EMAIL_USER5_FLAGS'] === 6 || details['EMAIL_USER5_FLAGS'] === 7 || details['EMAIL_USER5_FLAGS'] === 15,
              system: details['EMAIL_USER5_FLAGS'] === 8 || details['EMAIL_USER5_FLAGS'] === 15
            },
            7:{
              inputValue: details['EMAIL_SILENCE'],
            },
          }
          localStorage.setItem(
              "serverMessaging",
              JSON.stringify(serverMessaging)
          );
          let transfer: any = {
            dataTrans: details['DEVICE_DATA_TRANS_NETWORK_ENABLE'],
            lte: details['NETWORK_LTE_APN'],
            wlanSSID: details['NETWORK_WLAN_SSID'],
            wlanPasskey: details['NETWORK_WLAN_PASSKEY'],
            ftpUpload: details['FTP_UPLOAD'],
            ftpServer: details['FTP_SERVER'],
            ftpUser: details['FTP_USER'],
            ftpPassword: details['FTP_PASSWORD'],
            gpsEnable: details['DEVICE_GPS_ENABLE'],
            ledSignal: details['DEVICE_LED_CONFIG'],
            dataUrl: details['NETWORK_DATA_URL'],
            dataEp: details['NETWORK_DATA_EP'],
            configUrl: details['NETWORK_CONFIG_URL'],
            configEp: details['NETWORK_CONFIG_EP_GET'],
            configEpAck: details['NETWORK_CONFIG_EP_ACK'],
          };
          localStorage.setItem(
              "transferInfo",
              JSON.stringify(transfer)
          );
        });
    }
  }, [urllocation.pathname, i18n.language]);
  return (
    <>
      <Card
        title={t("project_information")}
        className="InputForms_container mt-4"
      >
        <div>
          <div className="grid align-items-center">
            <div className="col-12 lg:col-2">
              <h5 className="m-0 p-0">{t("project_name")}:</h5>
            </div>
            <div className="col-12 lg:col-4">
              <InputText
                  className="p-inputtext-sm block mb-0 ml-5"
                  value={projectName}
                  onChange={(e) => setProjectName(e.target.value)}
              />
            </div>
            <div className="col-12 py-0"><p className="error-message mb-0">{errors["projectName"]}</p></div>
          </div>

          <div className="grid align-items-center">
            <div className="col-12 lg:col-2">
              <h5 className="m-0 p-0">{t("comment")}:</h5>
            </div>
            <div className="col-12 lg:col-4">
              <InputText
                  className="p-inputtext-sm block mb-0 ml-5"
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
              />
            </div>
            <div className="col-12 py-0"><p className="error-message mb-0">{errors["comment"]}</p></div>
          </div>

          <div className="grid align-items-center">
            <div className="col-12 lg:col-2">
              <h5 className="m-0 p-0">{t("client")}:</h5>
            </div>
            <div className="col-12 lg:col-4">
              <InputText
                  className="p-inputtext-sm block mb-0 ml-5"
                  value={client}
                  onChange={(e) => setClient(e.target.value)}
              />
            </div>
            <div className="col-12 py-0"><p className="error-message mb-0">{errors["client"]}</p></div>
          </div>
          <div className="grid align-items-center">
            <div className="col-12 lg:col-2">
              <h5 className="m-0 p-0">{t("company")}:</h5>
            </div>
            <div className="col-12 lg:col-4">
              <InputText
                  className="p-inputtext-sm block mb-0 ml-5"
                  value={company}
                  onChange={(e) => setCompany(e.target.value)}
              />
            </div>
            <div className="col-12 py-0"><p className="error-message mb-0">{errors["company"]}</p></div>
          </div>
          <div className="grid align-items-center">
            <div className="col-12 lg:col-2">
              <h5 className="m-0 p-0">{t("location")}:</h5>
            </div>
            <div className="col-12 lg:col-4">
              <InputText
                  className="p-inputtext-sm block mb-0 ml-5"
                  value={location}
                  onChange={(e) => setLocation(e.target.value)}
              />
            </div>
            <div className="col-12 py-0"><p className="error-message mb-0">{errors["location"]}</p></div>
          </div>
          <div className="grid align-items-center">
            <div className="col-12 lg:col-2">
              <h5 className="m-0 p-0">{t("observer")}:</h5>
            </div>
            <div className="col-12 lg:col-4">
              <InputText
                  className="p-inputtext-sm block mb-0 ml-5"
                  value={observer}
                  onChange={(e) => setObserver(e.target.value)}
              />
            </div>
            <div className="col-12 py-0"><p className="error-message mb-0">{errors["observer"]}</p></div>
          </div>
          <div className="grid align-items-center">
            <div className="col-12 lg:col-2">
              <h5 className="m-0 p-0">{t("norm")}:</h5>
            </div>
            <div className="col-12 lg:col-4">
              <Dropdown
                  className="p-inputtext-sm  mb-0 ml-5"
                  value={norm}
                  options={norms}
                  onChange={onNormChange}
                  optionLabel="name"
                  placeholder={t('select_norm')}
              />
            </div>
            <div className="col-12 py-0"><p className="error-message mb-0">{errors["norm"]}</p></div>
          </div>

          <div className="flex flex-wrap align-items-center justify-content-center lg:justify-content-between">
            <p className="text-danger text-underline"></p>
            <p className="text-danger"></p>
            <div>
              <Button
                icon="pi pi-angle-right"
                label={t("next")}
                className="p-button-outlined p-button-secondary"
                onClick={async () => {
                  setErrors([]);
                  if (validate()) {
                    if(projectName === previousProjectName){
                      let projectInfo: any = {
                        projectName: projectName,
                        comment: comment,
                        client: client,
                        company: company,
                        location: location,
                        observer: observer,
                        norm: norm,
                      };
                      localStorage.setItem(
                          "projectInfo",
                          JSON.stringify(projectInfo)
                      );
                      props.onNext();
                    }
                    else{
                      const checkInfo = await projectService.checkProject(projectName, localStorage.getItem('userId'));
                      if (checkInfo === 'Project already exists') {
                        let error: any = {};
                        error["projectName"] = t('project_exist');
                        setErrors(error);
                      }
                      else {
                        let projectInfo: any = {
                          projectName: projectName,
                          comment: comment,
                          client: client,
                          company: company,
                          location: location,
                          observer: observer,
                          norm: norm,
                        };
                        localStorage.setItem(
                            "projectInfo",
                            JSON.stringify(projectInfo)
                        );
                        props.onNext();
                      }
                    }
                  }
                }}
              />
            </div>
          </div>
        </div>
      </Card>
    </>
  );
}
export default ProjectInfo;
